import {formatTimeToShow} from './helperFunctions';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    FORECAST_CODE,
    MATCHDAY_MODULE,
    PLACE_CODE,
    RACING_MODULE,
    REVERSE_FORECAST_CODE,
    REVERSE_TRICAST_CODE,
    SHOW_CODE,
    TO_WIN_CODE,
    TRICAST_CODE,
    CRICKET_MODULE, TENNIS_MODULE, BASEBALL_MODULE
} from '../constants/identifiers';
import {getModuleFromEventType} from './moduleHelpers';

export function getSelectedEventIndex(selectedEventId, events) {
    let selEvtIdx;

    events.find((ev, index) => {
        if (selectedEventId === ev.eventId) {
            selEvtIdx = index;
            return ev;
        }
        return false;
    });

    return selEvtIdx === undefined
        ? 0
        : selEvtIdx;
}

export function getGameTitle(eventTitle, eventTimeDate, systemLanguage) {

    let timeLeft = formatTimeToShow(eventTimeDate, systemLanguage);

    return {
        gameTitle: eventTitle,
        dayMonthYear: timeLeft.dayMonthYear,
        hoursMinutes: timeLeft.hoursMinutes
    };
}

export function getMarketInfo(currentBet, store) {

    let betInfo = {};
    betInfo.uniqueId = currentBet.uniqueId;

    let moduleType = getModuleFromEventType(currentBet.event.eventType);
    if (moduleType === RACING_MODULE) {

        let racersList = currentBet.racers;
        let racersInfoList = racersList.map((racer, index) => {
            let info = {};
            switch (parseInt(currentBet.betType.code, 10)) {
                case TO_WIN_CODE:
                case PLACE_CODE:
                case SHOW_CODE:
                case FORECAST_CODE:
                case REVERSE_FORECAST_CODE:
                case TRICAST_CODE:
                case REVERSE_TRICAST_CODE:
                    info.num = racer.num;
                    break;
                default:
                    info.num = '';
            }
            info.racer = racer.name;
            return info;
        });

        betInfo.betType = RACING_MODULE;
        betInfo.racersInfo = racersInfoList;
    } else if (moduleType === FOOTBALL_MODULE) {

        // let name = isNaN(currentBet.market.selection)
        //   ? getText(currentBet.market.selection, store)
        //   : currentBet.market.selection;

        betInfo.betType = FOOTBALL_MODULE;
        betInfo.footballSelection = currentBet.market.selection;
    } else if (moduleType === BASKETBALL_MODULE) {
        betInfo.betType = BASKETBALL_MODULE;
        betInfo.basketballSelection = currentBet.market.selection;
    } else if (moduleType === AMERICAN_FOOTBALL_MODULE) {
        betInfo.betType = AMERICAN_FOOTBALL_MODULE;
        betInfo.afSelection = currentBet.market.selection;
    } else if (moduleType === MATCHDAY_MODULE) {
        betInfo.betType = MATCHDAY_MODULE;
        betInfo.selection = currentBet.market.selection;
    } else if (moduleType === CRICKET_MODULE){
        betInfo.betType = CRICKET_MODULE;
        betInfo.cricketSelection = currentBet.market.selection;
    }else if (moduleType === TENNIS_MODULE){
        betInfo.betType = TENNIS_MODULE;
        betInfo.tennisSelection = currentBet.market.selection;
    }
    else if (moduleType === BASEBALL_MODULE){
        betInfo.betType = BASEBALL_MODULE;
        betInfo.baseballSelection = currentBet.market.selection;
    }

    betInfo.marketCode = currentBet.betType.code;

    return betInfo;
}

export function getEventFromEventList(eventId, gameChannel, eventList) {
    let event;
    if (eventList && eventList.length) {
        event = eventList.find((evt) => evt.eventId === eventId && evt.channel === gameChannel);
    }
    return event;
}

export function isEventInNoMoreBets(event, nmbEventList) {
    if (event && nmbEventList && nmbEventList.length) {
        return nmbEventList.find((evt) => event.eventId === evt.eventId && event.channel === evt.gameChannel);
    }
    return false;
}

export function groupMatchdayEvents(events) {
    const groupBy = (array, key) => {
        return array.reduce((result, currentValue) => {
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            return result;
        }, {});
    };

    events = Object.values(groupBy(events, 'leagueDay')).map((event) => {
        event.channel = event[0].channel;
        event.eventTime = event[0].eventTime;
        event.eventType = event[0].eventType;
        return event;
    });

    events.sort((md1, md2) => (md1.eventTime > md2.eventTime) ? 1 : -1)
    return events;
}


// WEBPACK FOOTER //
// ./src/helpers/eventHelpers.js